import { useEmpresas } from "@/hooks/use-data";

export function useIsEmpresaTestMode(
  empresaId?: string | null,
): boolean {
  const { data: empresas } = useEmpresas();
  if (!empresaId) return false;
  const empresa = empresas?.find((e) => e.id === empresaId);
  return !!(empresa as { modoTeste?: boolean } | undefined)?.modoTeste;
}
